/// <reference path="../_references.ts"/>

module App.WorkOrder {
	import Appointment = App.Appointments.Appointment;
	import FinancePlan = App.Appointments.FinancePlan;
	import ServicePlan = App.Appointments.ServicePlan;
	import ServiceRequest = App.Appointments.ServiceRequest;
	import ServiceableItem = App.ItemManagement.ServiceableItem;

	export class WorkOrderService {
		constructor(
			private $http: ng.IHttpService,
			public Constants: IConstants
		) {

		}

		getSummary(serviceRequestId: number): ng.IHttpPromise<Summary> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/summary`);
		}

		getServicePlans(serviceRequestId: number): ng.IHttpPromise<ServicePlan[]> {
			return this.$http.get(`${this.Constants.apiUrl}serviceplan?visible=1`, {
				params: {
					//service_request_id: serviceRequestId
				}
			});
		}

		email(serviceRequestId: number, email: string, packages?: Number[]): ng.IHttpPromise<{}> {
			return this.$http.post(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/email`, {
				email: email,
				packages: packages || null
			});
		}

		sendApprovalText(srId: number, phone: string, appointmentId?: number): ng.IHttpPromise<{}> {
			return this.$http.post(`${this.Constants.apiUrl}servicerequest/${srId}/signtoken`, {
				phone: phone,
				appointment: appointmentId,
			});
		}

		sendApprovalEmail(srId: number, email: string, appointmentId?: number): ng.IHttpPromise<{}> {
			return this.$http.post(`${this.Constants.apiUrl}servicerequest/${srId}/signtoken`, {
				email: email,
				appointment: appointmentId,
			});
		}

		getFinanceCompanies(serviceRequestId?: number): ng.IHttpPromise<FinancePlan[]> {
			return this.$http.get(`${this.Constants.apiUrl}financecompany`, {
				params: {
					service_request: serviceRequestId
				}
			});
		}

		getRecommendationPreview(packageIds: number[], allowNonRec: boolean, params?: object): ng.IHttpPromise<string> {
			return this.$http.post(
				`${this.Constants.apiUrl}recommendation/preview.html`, {
					ids: packageIds,
					allowNonRec: allowNonRec
				}, {
					params: params || {}
				}
			);
		}

		updateServicePlan(serviceRequestId: number, servicePlan: ServicePlan): ng.IHttpPromise<ServiceRequest> {
			return this.$http.put(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}`, {
				service_plan: servicePlan
			});
		}

		updateFinancePlan(serviceRequestId: number, financePlan: FinancePlan): ng.IHttpPromise<ServiceRequest> {
			return this.$http.put(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}`, {
				finance_plan: financePlan
			});
		}

		getFinancePlan(financePlanId: number, serviceRequestId?: number): ng.IHttpPromise<FinancePlan> {
			return this.$http.get(`${this.Constants.apiUrl}financeplan/${financePlanId}`, {
				params: {
					service_request: serviceRequestId
				}
			});
		}

		fetchSignature(serviceRequestId: number): ng.IHttpPromise<Approval> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/approval`);
		}

		saveSignature(
			serviceRequestId: number,
			dataUrl: string,
			printName: string,
			amount: string,
			terms: TermsConditions[]
		): ng.IHttpPromise<Approval> {
			return this.$http.post(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/approval`, {
				data_url: dataUrl,
				print_name: printName,
				amount: amount,
				terms: terms
			});
		}

		addAdjustment(serviceRequestId: number, adjustmentCode: string) {
			return this.$http.put(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}`, {
				coupon: adjustmentCode
			})
		}

		overrideSalesTax(serviceRequestId: number, salesTaxOverride: number, taxType: string) {
			let obj = null;

			switch(taxType) {
				case "material" :
					obj = {sales_tax_override_material: salesTaxOverride};
					break;
				case "labor" :
					obj = {sales_tax_override_labor: salesTaxOverride};
					break;
				case "total" :
					obj = {sales_tax_override_material: salesTaxOverride , sales_tax_override_labor: 0};
					break;
			}

			return this.$http.put(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}`, obj);
		}

		public static Factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) => {
				return new WorkOrderService($http, Constants);
			};

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}
	}
}